module.exports = __webpack_public_path__ + "assets/images/slider-img.jpg?_fcfdb56fa273";